import * as React from 'react'

import Heading from '../../components/Heading/Heading'
import ProcedurePreviewGrid from '../../components/ProcedurePreviewGrid/ProcedurePreviewGrid'
import type { ProcedurePreviewStepViewModel } from '../../view-models/ProcedurePreviewStepViewModel'
import styles from './procedurePreview-style.css'

type Props = {
  items: Array<ProcedurePreviewStepViewModel>
  title?: string
}
type State = {}

class ProcedurePreview extends React.Component<Props, State> {
  static displayName = 'ProcedurePreview'
  static defaultProps = {}

  render() {
    const { items, title } = this.props

    return (
      <div className={styles.prodedure}>
        {title && (
          <Heading level={2} tag={`h2`} className={styles.heading}>
            {title}
          </Heading>
        )}
        <ProcedurePreviewGrid items={items} moduleName={'forlob-visning'} />
      </div>
    )
  }
}

export default ProcedurePreview
